import './setting';
import envCheck from './util';
export default envCheck;